// extracted by mini-css-extract-plugin
export default {"root":"AllModal_root__360KW","titles":"AllModal_titles__tNlS-"};